import React from 'react';

class NotFound extends React.Component {
    componentDidMount () {
        setTimeout(() => {
            window.location.href = process.env.REACT_APP_MAINPAGE_URL;
            window.location.replace(process.env.REACT_APP_MAINPAGE_URL);
        }, 5000);
    }

    render () {
        return (
            <div className="container">
                <div className="row">
                    <div className="col-12 text-center mt-5">
                        不好意思，沒有這個頁面。
                    </div>
                    <div className="col-12 text-center mt-1">
                        五秒後協助跳轉，或按
                        <a href={process.env.REACT_APP_MAINPAGE_URL}>這裡</a>
                    </div>
                </div>
            </div>
        );
    }
}

export default NotFound;
